export const MIN_WIDTH = 200;
